import axios from "axios";

export default axios.create({
  baseURL: "https://onlineshop-cargo.com/api",

  headers: {
    "Content-type": "application/json"
  }
});